import { useQuery } from '@tanstack/react-query';

import { useWorkspaces } from '../../pages/Orchestrator/WorkspaceProvider';
import { useCloudPlatformDiscovery } from '../../utils/hooks';
import { useEngine } from './hooks';
import { useEngineStateMonitor } from './useEngineStateMonitor';

/**
 * Hook that monitors engine state transitions and shows notifications
 * when engines transition from STARTING to RUNNING or FAILED.
 * This is a convenience wrapper around useEngineStateMonitor that sets up
 * its own polling query. Used in Navigation component for bell icon notifications.
 */
export const useEngineStateMonitorNotifications = () => {
  const discovery = useCloudPlatformDiscovery();
  const { ACTIVE_WORKSPACE_NAME } = useWorkspaces();
  const { searchEngines } = useEngine();
  const { trackEngines, handleStateTransitions } = useEngineStateMonitor();

  const queryKey = ['aiEngines', ACTIVE_WORKSPACE_NAME, 'ALL', []];
  const isEnabled = !!discovery?.aiEngineManagerApiUrl;

  useQuery({
    queryKey,
    queryFn: async () => {
      const engines = await searchEngines([], ACTIVE_WORKSPACE_NAME);
      return engines || [];
    },
    enabled: isEnabled,
    refetchInterval: isEnabled ? 5_000 : false,
    onSuccess: (engines) => {
      trackEngines(engines);
      handleStateTransitions(engines);
    },
  });
};
